"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Hook to detect clicks outside of a ref, only on web.
 *
 * @param {React.RefObject<HTMLElement>} ref
 *   Reference to the element you want to “protect.”
 * @param {() => void} onOutside
 *   Callback invoked when a click occurs outside that ref.
 * @param {boolean} [enabled=true]
 *   Flag to enable or disable the outside-click detection at runtime.
 *   @deprecated Will be removed in next major release; detection will always be enabled.
 */

function useDetectOutsideClick(ref, onOutside) {
  let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  _react.default.useEffect(() => {
    if (!enabled || _Platform.default.OS !== 'web') {
      return undefined;
    }
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        onOutside();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onOutside, enabled]);
}
var _default = exports.default = useDetectOutsideClick;